module.exports = __webpack_public_path__ + "0e0c2a2795952a6748f219a4c6b11397.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Avatar/placeholder.png
// module id = 695
// module chunks = 0